
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.652 2.144a.597.597 0 01.72-.044l.058.044 4.633 3.973a.597.597 0 01.204.379l.004.074-.007.833a.597.597 0 01-1.19.07l-.004-.07.007-.558-4.035-3.46L3.86 6.98v5.702h1.158c.306 0 .559.231.593.528l.004.07c0 .306-.23.558-.527.593l-.07.004H3.264a.597.597 0 01-.593-.528l-.004-.07V6.708c0-.15.055-.292.154-.401l.053-.052 4.778-4.11zm6.294 9c-.255-.423-1.663-2.544-4.054-2.476-2.211.054-3.49 1.904-3.838 2.476a.365.365 0 000 .38C6.305 11.94 7.653 14 10.008 14h.1c2.211-.053 3.495-1.904 3.838-2.475a.365.365 0 000-.381zM10 12.667A1.333 1.333 0 1110 10a1.333 1.333 0 010 2.667z"}})])
          )
        }
      }
    